import React, { Component } from "react";

import Image from "components/image/image";

import "./sizeChart.css";

export default class SizeChart extends Component {
  render() {
    return (
      <div className="sizeChart">
        {this.props.image !== undefined && (
          <Image src={this.props.image.fields.file.url} />
        )}
        <table className="chart">
          <tbody>
            {this.props.rows.map((row, index) => (
              <tr key={index}>
                {row.map((cell, index) => (
                  <td key={index}>{cell || ""}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
